/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { EVENT_NAMES, PROP_NAMES, type TOUR_BUTTON_TYPES, track } from '@zcode/mixpanel'
import type { Listable, MaybeEmptyProperty, Pin, RawPinInventorySearch } from '@zcode/state-type'
import type { Values } from '@zcode/utility-types'
import type { Dispatch, GetState } from '../../types'
import { getCommonProps } from '../helpers/getCommonProps'

export const mixpanelClickTourAvailability =
  (
    entity: Listable | MaybeEmptyProperty | Pin<RawPinInventorySearch> | null | undefined,
    tourButtonType: Values<typeof TOUR_BUTTON_TYPES>
  ) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const payload = getCommonProps({
      event: EVENT_NAMES.CLICK_TOUR_AVAILABILITY,
      state,
      entity,
    })
    track({
      event: EVENT_NAMES.CLICK_TOUR_AVAILABILITY,
      payload: { ...payload, [PROP_NAMES.TOUR_BUTTON_TYPE]: tourButtonType },
    })
  }
